export enum CompanyStatusesEnum {
  OK = 'ok',
  BLOCKED = 'blocked',
  BLOCKED_BILLING = 'blocked_billing',
}
